import { CheckIcon, CloseIcon, FinancialContributionIcon, InitialDetails } from "@fla/components";
import { useForm } from "react-hook-form";

const fc = [
  "Income earned throughout the relationship.",
  "Paying for deposits on property.",
  "Paying for ongoing property costs (eg: mortgage, bills, rates)",
  "Paying for ongoing living expenses (e.g: groceries, entertainment)",
  "Paying for renovations to property or maintenance of vehicles",
  "Purchasing of any assets or acquiring investments",
  "Paying for the costs of raising children"
];

const nfc = [
  "Child support",
  "Repayable loans",
  "Renovations or work that you have done yourself (excluding costs)",
  "Anything you have not spent money on"
];

const fce = [
  "Each of you brought similar assets into the relationship at the start.",
  "Each parties have generally contributed the same to property purchasing, earn similar incomes, jointly paid for bills, groceries or living expenses throughout the relationship.",
  "Further, neither of you had received significant gifts, inheritances, workers compensation or redundancies that went towards these contributions."
];

const nfce = [
  "One of you earn significantly more over the course of the relationship.",
  "One of you brought significant assets to the relationship (e.g property, vehicles etc.)",
  "One of you contributed greatly to acquiring assets (e.g paying for most of a deposit, mortgage etc.)",
  "One of you received significant gifts, inheritances, compensation or redundancy. We will ask more questions on this later."
];

interface IProps {
  formId: string;
  store: InitialDetails;
  onSubmit: (values: InitialDetails) => void;
}

export default function NonFinancialContributions({ onSubmit, formId, store }: IProps) {
  const { handleSubmit } = useForm({
    mode: "all",
    defaultValues: store
  });

  return (
    <form id={formId} className="space-y-5" onSubmit={handleSubmit(onSubmit)}>
      <div className="mb-8 pb-8 border-b">
        <FinancialContributionIcon classes="w-14 h-14 mx-auto mb-5" />

        <h3 className="text-center">Financial Contributions</h3>
      </div>

      <div className="space-y-5">
        <p className="text-sm">
          <b>Financial contributions </b> refers to things you or {store?.spouse?.first_name} used your income or other
          money to purchase, acquire or maintain. This includes things such as:
        </p>
        <ul className="text-sm space-y-3">
          {fc.map((item, idx) => (
            <li key={+idx} className="flex p-3 rounded-[10px] bg-[#f2f2f2]">
              <CheckIcon classes="fill-current text-green-600" />
              <p className="w-full pl-2">{item}</p>
            </li>
          ))}
        </ul>
      </div>

      <div className="space-y-5">
        <p className="text-sm">This is not a Financial contribution:</p>
        <ul className="text-sm space-y-3">
          {nfc.map((item, idx) => (
            <li key={+idx} className="flex p-3 rounded-[10px] bg-[#f2f2f2]">
              <CloseIcon strokeColor="text-red-500" />
              <p className="w-full pl-2">{item}</p>
            </li>
          ))}
        </ul>
      </div>
      <div className="space-y-5">
        <p className="text-sm">
          You will be asked if financial contributions were considered&nbsp;
          <strong>generally equal</strong>. You should think if you:
        </p>
        <ul className="text-sm mb-4 space-y-3">
          {fce.map((item, idx) => (
            <li key={+idx} className="flex items-center p-3 rounded-[10px] bg-[#f2f2f2]">
              <div className="w-5 h-5 rounded-full bg-[#999] text-white flex items-center justify-center text-xs">
                {idx + 1}
              </div>
              <p className="w-full pl-2">{item}</p>
            </li>
          ))}
        </ul>
      </div>

      <div className="space-y-5">
        <p className="text-sm">Examples of not-equal contributions:</p>
        <ul className="text-sm space-y-3">
          {nfce.map((item, idx) => (
            <li key={+idx} className="flex items-center p-3 rounded-[10px] bg-[#f2f2f2]">
              <div className="w-5 h-5 rounded-full bg-[#999] text-white flex items-center justify-center text-xs">
                {idx + 1}
              </div>
              <p className="w-full pl-2">{item}</p>
            </li>
          ))}
        </ul>
      </div>
    </form>
  );
}
